import { cva } from "class-variance-authority"

export const multiSelectListboxVariants = cva(["list-none", "overflow-auto", "!p-0", "outline-none"], {
  variants: {},
})

export const multiSelectPopupVariants = cva(
  ["absolute z-[9999]", "left-0 top-full mt-1", "rounded-md bg-white", "shadow-md", "border border-gray-200"],
  {
    variants: {
      width: {
        xs: "w-20",
        sm: "w-32",
        md: "w-[320px]",
        lg: "w-96",
        xl: "w-[480px]",
        "2xl": "w-[640px]",
        full: "w-full",
      },
    },
    defaultVariants: {
      width: undefined,
    },
  }
)
